import React from 'react';

const Contacts = () => {
    return (
        <div className="container">
         <h4 className="center">Contacts</h4>
         
         <p> this my about page people</p>
        </div>
    )
}

export default Contacts